/*
* バックグラウンド
*/
<template>
	<div id="bg" ref="bgpanel" :class="{waitMode:wait}">
		<div id="bg-content" v-if="show">
			<div id="bg-wait" v-if="wait">
				{{ message }}<br>
				<wait-bar :height="'8px'" :fill="'rgba(131,188,242,1)'" style="margin-left:2px"></wait-bar>
			</div>
		</div>
	</div>
</template>

<script>
import base from '@/components/base.vue';
export default {
	mixins: [base],
	name: "ct-bg",
	props: {
		show: { type:Boolean, default:false },
		wait: { type:Boolean, default:false },
		message: { type:String, default:"しばらくお待ち下さい。。。" }
	},
	data() {
		return {
			timer: ""
		}
	},
	watch: {
		show(val) {
			if (val) {
				if (this.$el.style.visibility == "visible") {
					return;
				}
				
				if (this.wait) {
					let _self = this;
					this.timer = setTimeout(function(){
						_self.$el.style.visibility = "visible";
					}, 1000);
				} else {
					this.$el.style.visibility = "visible";
				}
			} else {
				clearTimeout(this.timer);
				this.$el.style.visibility = "hidden";
			}
		}
	}
}
</script>

<style lang="less" scoped>
@import '../../less/const.less';
#bg {
	position: fixed;
	width: 100vw;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.6);
	z-index: 2147483600;
	visibility: hidden;
	display: flex;
	justify-content: center;
	align-items: center;
}

#bg-wait {
	color: white;
}

.waitMode {
	cursor: wait;
}
</style>



// WEBPACK FOOTER //
// src/components/component/background.vue